import React from 'react';
import { Band } from './Band';
import { atsBlocks } from '../../data/site';
export function WhyNotATS() {
  return <Band dark id="independence" eyebrow="Why an ATS can't build this" title="The system that made the shortlist can't audit the shortlist." description="Independence is not a feature an applicant tracking system can ship. It is a structural position, and the vendor that produced the shortlist cannot occupy it." data-id="element-418" data-mp="21xblauyd3wwj">
      <div className="grid gap-4 lg:grid-cols-3" data-id="element-419" data-mp="1e7zc3v31bou8">
        {atsBlocks.map((block, i) => <article key={block.title} className="flex flex-col rounded-2xl border border-white/10 bg-white/[0.03] p-7 lg:p-8" data-id="element-420" data-mp="1j8ww8d7lusyd" data-mpi={i}>
            <span className="font-mono text-xs uppercase tracking-[0.2em] text-teal-light" data-id="element-421" data-mp="14c5x851ufj9a">
              {String(i + 1).padStart(2, '0')}
            </span>
            <h3 className="mt-5 font-display text-2xl font-light text-bone" data-id="element-422" data-mp="2yo46u842eh5p">
              {block.title}
            </h3>
            <p className="mt-4 max-w-[46ch] text-[15px] leading-relaxed text-bone/65" data-id="element-423" data-mp="33mfdyb2z6dk8">
              {block.body}
            </p>
          </article>)}
      </div>
    </Band>;
}